if (!customElements.get('cart-toast')) {
  customElements.define(
    'cart-toast',
    class CartToast extends HTMLElement {
      constructor() {
        super();
        this.toastDuration = 2500;
        this.exitDuration = 320;
        this.cartUpdateUnsubscriber = undefined;
        this.headerEl = null;
        this.scrollRafId = null;
        this.onScrollHandler = this.onScroll.bind(this);
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
        this.headerEl = document.querySelector('.section-header');
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
        this.stopTrackingHeader();
      }

      updateHeaderOffset() {
        if (!this.headerEl) return;
        const bottom = Math.max(this.headerEl.getBoundingClientRect().bottom, 0);
        this.style.setProperty('--cart-toast-header-offset', `${bottom}px`);
      }

      startTrackingHeader() {
        if (this.scrollRafId !== null || !this.headerEl) return;
        this.updateHeaderOffset();
        window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      }

      stopTrackingHeader() {
        window.removeEventListener('scroll', this.onScrollHandler);
        if (this.scrollRafId !== null) {
          cancelAnimationFrame(this.scrollRafId);
          this.scrollRafId = null;
        }
        this.style.removeProperty('--cart-toast-header-offset');
      }

      onScroll() {
        if (this.scrollRafId !== null) return;
        this.scrollRafId = requestAnimationFrame(() => {
          this.scrollRafId = null;
          this.updateHeaderOffset();
        });
      }

      onCartUpdate(event) {
        if (event.source !== 'product-form') return;

        const cartData = event.cartData;
        const sectionHTML = cartData && cartData.sections && cartData.sections['cart-toast-product'];
        if (!sectionHTML) return;

        const key = event.parentLineKey || (cartData.items && cartData.items[0] && cartData.items[0].key);
        if (!key) return;

        const parsed = new DOMParser().parseFromString(sectionHTML, 'text/html');
        const itemNode = parsed.querySelector(`#cart-toast-product-${CSS.escape(key)}`);
        if (!itemNode) return;

        this.appendToast(itemNode);
      }

      appendToast(itemNode) {
        const node = itemNode.cloneNode(true);
        node.removeAttribute('id');

        this.appendChild(node);
        this.startTrackingHeader();

        requestAnimationFrame(() => {
          node.classList.add('cart-toast__item--visible');
        });

        this.scheduleDismiss(node);

        node.addEventListener('mouseenter', () => this.clearDismiss(node));
        node.addEventListener('mouseleave', () => this.scheduleDismiss(node));
        node.addEventListener('focusin', () => this.clearDismiss(node));
        node.addEventListener('focusout', () => this.scheduleDismiss(node));
      }

      scheduleDismiss(node) {
        this.clearDismiss(node);
        node._dismissTimer = setTimeout(() => this.dismiss(node), this.toastDuration);
      }

      clearDismiss(node) {
        if (node._dismissTimer) {
          clearTimeout(node._dismissTimer);
          node._dismissTimer = null;
        }
      }

      dismiss(node) {
        if (!node.isConnected) return;
        node.classList.remove('cart-toast__item--visible');
        node.classList.add('cart-toast__item--exit');
        setTimeout(() => {
          if (node.isConnected) node.remove();
          if (!this.firstElementChild) this.stopTrackingHeader();
        }, this.exitDuration);
      }
    }
  );
}
